import * as React from 'react';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import { ApplessTourInfo } from '../../../../../api/Prospect';
import '../../../../../styles/TourAccessPopup.css';
import TourAccessInformation from '../../../../common/TourAccessInformation';

interface Props {
    isOpen: boolean;
    close: () => void;
    accessInfo: ApplessTourInfo;
    keyLocations?: any;
    setViewAmazonInstructions?: any;
    setSelectedAmazonLock?: any;
}

const TourAccessPopup = (props: Props) => {
    if(props.accessInfo.isAmazonKeyEnabled){
        return <Modal isOpen={props.isOpen} centered={true}>
                    <ModalHeader className="tour-header" toggle={props.close}>{'Access Information'}</ModalHeader>
                    <ModalBody className="reschedule-modal">
                        <div>
                            { props.keyLocations && props.keyLocations.map((loc: any)=>{
                                return <div className='d-flex align-items-center mb-3'><p style={{ fontSize: '16px', margin: '0px', width: '220px' }}>{loc.name}</p>
                                    <div onClick={()=>{
                                        props.setViewAmazonInstructions(true)
                                        props.setSelectedAmazonLock(loc)
                                    }}>
                                        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2 3C2 2.20435 2.31607 1.44129 2.87868 0.87868C3.44129 0.31607 4.20435 0 5 0L7 0C7.79565 0 8.55871 0.31607 9.12132 0.87868C9.68393 1.44129 10 2.20435 10 3V5C10.5304 5 11.0391 5.21071 11.4142 5.58579C11.7893 5.96086 12 6.46957 12 7V14C12 14.5304 11.7893 15.0391 11.4142 15.4142C11.0391 15.7893 10.5304 16 10 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V7C0 6.46957 0.210714 5.96086 0.585786 5.58579C0.960859 5.21071 1.46957 5 2 5V3ZM4 5H8V3C8 2.73478 7.89464 2.48043 7.70711 2.29289C7.51957 2.10536 7.26522 2 7 2H5C4.73478 2 4.48043 2.10536 4.29289 2.29289C4.10536 2.48043 4 2.73478 4 3V5ZM7 10C7 9.73478 6.89464 9.48043 6.70711 9.29289C6.51957 9.10536 6.26522 9 6 9C5.73478 9 5.48043 9.10536 5.29289 9.29289C5.10536 9.48043 5 9.73478 5 10V11C5 11.2652 5.10536 11.5196 5.29289 11.7071C5.48043 11.8946 5.73478 12 6 12C6.26522 12 6.51957 11.8946 6.70711 11.7071C6.89464 11.5196 7 11.2652 7 11V10Z" fill="#27BAF9"/>
                                        </svg>
                                    </div>
                                </div>
                            })}
                        </div>
                    </ModalBody>
                </Modal>
    }
    return (
        <Modal isOpen={props.isOpen} centered={true}>
            <ModalHeader className="tour-header" toggle={props.close}>{'Access Information'}</ModalHeader>
            <ModalBody className="reschedule-modal">
                <TourAccessInformation
                    accessCodes={props.accessInfo.accessCodes}
                    prospectFacingText={true}
                    bmxAccessCodes={props.accessInfo.bmxAccessCodes}
                />
            </ModalBody>
        </Modal>
    );
};

export default TourAccessPopup;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/tour/applessTour/TourAccessPopup.tsx